export enum BetType {
  Single,
  Express,
}
